import { USER_ROLES_WITHOUT_GUEST_AND_USER } from 'cpool-constants';
import type { Resolver } from 'cpool-schemas';
import { z } from 'zod';

import { UserGroupContextZod, UsersTableDefinitionZod } from '../tables';

type Arguments = {
    // only honoured for admins, everybody else is limited to the own scope
    corporationId?: string;
    roles: string[];
};

export const schemaUserResolver_GetAssignableUsersArgs = z.object({
    corporationId: z.string().uuid().optional(),
    roles: z.array(z.nativeEnum(USER_ROLES_WITHOUT_GUEST_AND_USER)).min(1),
});

export const schemaUserResolver_GetAssignableUsers = z.array(
    UsersTableDefinitionZod.pick({ firstName: true, id: true, lastName: true, role: true, teamId: true }).merge(
        UserGroupContextZod,
    ),
);

export type SchemaUserResolver_GetAssignableUsers = z.infer<typeof schemaUserResolver_GetAssignableUsers>;

export type UserResolver_GetAssignableUsers = Resolver<Arguments, SchemaUserResolver_GetAssignableUsers>;
